import qs from 'query-string';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import {
    localize,
    selectLocale,
} from 'wanderu-i18n';

import localesConfig from '../../../config/explorer.locales';
import {
    setDate,
    setPrice,
} from '../../ducks/Filters';
import {
    fetchCityFromPlaceId,
    setOriginCityActive,
} from '../../ducks/OriginCities';
import { validCitiesSelector } from '../../ducks/PopularCities';
import { fetchLowestPrices } from '../../ducks/Pricings';
import { setInvalidSearch } from '../../ducks/Status';
import { Explorer } from './Explorer';

function mapStateToProps(state, ownProps) {
    const {
        filters,
        originCities,
        status,
    } = state.explorer;
    const {
        date,
        price,
    } = filters;
    const queries = qs.parse(ownProps?.location?.search);
    const placeId = queries?.placeId || '';

    return {
        cities: validCitiesSelector(state),
        date,
        locale: selectLocale(state) || localesConfig.defaultLocale,
        originCities,
        originCity: originCities[originCities?.activeWcityid] || {},
        placeId,
        price,
        status,
    };
}

const mapDispatchToProps = {
    fetchCityFromPlaceId,
    fetchLowestPrices,
    setDate,
    setInvalidSearch,
    setOriginCityActive,
    setPrice,
};

const LocalizedExplorer = localize(Explorer, localesConfig.namespace);
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LocalizedExplorer));
